import type { FunctionComponent } from "react";

import { page as PostiesPage } from "~/pages/posties";

import { PostiesHeaderActions } from "./posties-header-actions";
import {
  Container,
  StyledLogoLink,
  StyledLogoPosties,
  StyledPostiesHeaderMenu,
  Wrapper,
} from "./styles";

export type Props = {
  className?: string;
};

export const PostiesHeader: FunctionComponent<Props> = ({ className }) => {
  const { pathname: postiesPagePathname, query: postiesPageQuery } = PostiesPage.route({});

  return (
    <Container className={className}>
      <Wrapper>
        <StyledLogoLink
          as="/posties"
          pathname={postiesPagePathname}
          query={{ ...postiesPageQuery }}
        >
          <StyledLogoPosties />
        </StyledLogoLink>
        <StyledPostiesHeaderMenu />
        <PostiesHeaderActions />
      </Wrapper>
    </Container>
  );
};

PostiesHeader.displayName = "PostiesHeader";
